import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';

const FAQAccordionUI = ({ title, content, isActive, toggleAccordion }) => {
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('0px');

  useEffect(() => {
    // adding unset maxHeight to support inner accordions
    if (isActive) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
      setTimeout(() => {
        setMaxHeight('unset');
      }, 600);
    } else {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
      setTimeout(() => {
        setMaxHeight('0px');
      }, 100);
    }
  }, [isActive]);

  return (
    <div className="flex flex-col items-start mb-4">
      <CtaButton
        noLinkPadding
        spacing="sm"
        hasArrow={false}
        styling="link"
        color="brand"
        className="cursor-pointer [&>span]:w-full"
        onClick={toggleAccordion}
        block
        textClassName="w-full [&>span]:w-full"
      >
        <div className="flex text-left justify-between w-full">
          <span className="text-sm font-bold normal-case">{title}</span>
          <span className="leading-[1.3125rem] transition-[transform_.6s_ease]">
            {isActive ? '-' : '+'}
          </span>
        </div>
      </CtaButton>
      <div
        className="text-sm text-gray overflow-hidden transition-[max-height_.6s_ease] [&_p]:text-sm [&_p]:mb-0"
        ref={contentRef}
        style={{ maxHeight }}
      >
        <div className="text-sm mt-3 mx-0 mb-4">{content}</div>
      </div>
    </div>
  );
};

FAQAccordionUI.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  isActive: PropTypes.bool,
  toggleAccordion: PropTypes.func,
};

export default FAQAccordionUI;
